module.exports = __webpack_public_path__ + "img/storage-dashboard.a722fc3d.svg";